import { ref } from 'vue';

export const currentId = ref();
export const currentData = ref();
